import {
	createValidator,
	required,
	email,
	minLength,
	maxLength
} from 'utils/form/validation';

export default createValidator({
	rating: [required],
	ratingPrice: [required],
	ratingCleanliness: [required],
	ratingRecommended: [required],
	title: [required, minLength(5), maxLength(75)],
	message: [required, minLength(30), maxLength(2000)],
	nickname: [required],
	email: [required, email],
	confirmationCode: [required]
});
